module.exports = __webpack_public_path__ + "site/img/212.aff60f34.jpg";